export default __webpack_public_path__ + "static/media/star.58335d0f.svg";